import Id from './Id';
import Name from './Name';
import Category from './Category';
import GlaNumber from './GlaNumber';
import Price from './Price';
import QuantityUnit from './QuantityUnit';
import RegistrationNumber from './RegistrationNumber';
import Created from './Created';
import Updated from './Updated';
import Status from './Status';
import Vat from './Vat'

export const labels = {
  Id: 'Azonosító',
  Name: 'Név',
  Category: 'Kategória',
  GlaNumber: 'Főkönyvi szám',
  Price: 'Netto Ár',
  QuantityUnit: 'Mennyiségi egység',
  RegistrationNumber: 'Szj szám',
  Status: 'Státusz',
  Vat: 'Áfa',
  Created: 'Létrehozva',
  Updated: 'Módosítva'
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
  fixed: true,
}, {
  value: 'Category',
}, {
  value: 'GlaNumber',
}, {
  value: 'Price',
}, {
  value: 'QuantityUnit',
}, {
  value: 'RegistrationNumber',
}, {
  value: 'Status',
}, {
  value: 'Vat',
}, {
  value: 'Updated',
}, {
  value: 'Created',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
  fixed: true,
}, {
  value: 'GlaNumber',
}, {
  value: 'Price',
}, {
  value: 'Status'
}];

export const defaultSort = {
  prop: Name.propName,
  order: 'ascending'
};

export default {
  Id,
  Name,
  Category,
  QuantityUnit,
  GlaNumber,
  RegistrationNumber,
  Price,
  Status,
  Vat,
  Updated,
  Created,
}
